/**
 * The bell (docs/mockups/notifications.html, slide 1): in the brand row on Today, Play,
 * Nest and You, left of ≡. A red dot while notifications are off here (or need the
 * home screen), filled once they're on, a plain outline when blocked or stopped. Hidden
 * where push can't work, or while the api has it off. It opens the one sheet, as its trigger.
 */
import { useEffect, useRef } from 'react';

import { NotifyTrigger } from './host.tsx';
import { noteStateSeen, useNotifyStatus } from './push.ts';
import { bellLabel, bellLook } from './state.ts';
import '../styles/push.css';

export function BellIcon({ filled = false }: { filled?: boolean }) {
	return (
		<svg viewBox="0 0 24 24" aria-hidden="true" className={filled ? 'bell-ic filled' : 'bell-ic'}>
			<path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z" />
			<path d="M10 20.5a2.2 2.2 0 0 0 4 0" />
		</svg>
	);
}

export function NotifyBell() {
	const { state } = useNotifyStatus();
	const ref = useRef<HTMLButtonElement>(null);
	useEffect(() => {
		if (state) noteStateSeen(state);
	}, [state]);
	if (!state) return null;
	const look = bellLook(state);
	if (look === 'hidden') return null;
	return (
		// The sheet's Radix trigger (aria-haspopup, aria-expanded, aria-controls; focus comes back here).
		<NotifyTrigger req={{ surface: 'bell', anchor: () => ref.current }}>
			<button ref={ref} type="button" className="icon-btn bell-btn" data-look={look} aria-label={bellLabel(state)} data-testid="notify-bell">
				<BellIcon filled={look === 'filled'} />
				{look === 'dot' && <span className="bell-dot" aria-hidden="true" />}
			</button>
		</NotifyTrigger>
	);
}
